import React from "react";
import { Text, Icon } from "shared";
import { getDate } from "utils/time";
import { useTranslation } from "react-i18next";
import { Circle } from "assets";
import { useHcp } from "api/hooks/useHCPs";

const Status: React.VFC = () => {
  const { t } = useTranslation();
  const { data: hcp } = useHcp();
  if (!hcp) return null;

  const isDeleted = !!hcp.deleted_at;

  return (
    <Text paragraph mb={0} data-testid="status">
      <Icon
        of={Circle}
        success={!isDeleted}
        error={isDeleted}
        size={0.7}
        aria-label={isDeleted ? "Inactive account" : "Active account"}
      />
      <Text ml={1} bold>
        {hcp.id}
      </Text>
      <Text right>
        <Text light ml="auto">
          {isDeleted ? t`patient.deleted` : t`patients.created`}:{" "}
        </Text>
        <Text bold>{getDate((isDeleted ? hcp.deleted_at : hcp.created_at) ?? "")}</Text>
      </Text>
    </Text>
  );
};

export default Status;
